export default "__VITE_ASSET__DlNYMPGD__"